import { createIrisApiClient, basePaths } from '@/api/clients/iris/irisapi'
import { filterParamSerializer } from 'API/utilities/filterParamSerializer'
const irisMeasurementClient = createIrisApiClient(basePaths.measurement)

const createImageMeasurement = (measurementDetailsObj) => {
  return irisMeasurementClient.post(`/`, {
    points: measurementDetailsObj.points,
    image_uuid: measurementDetailsObj.imageUuid,
    annotation_uuid: measurementDetailsObj.annotationUuid,
  })
}

const updateImageMeasurement = (measurementDetailsObj) => {
  const measurementUuid = measurementDetailsObj.measurementValues.measurementUuid
  return irisMeasurementClient.patch(`/${measurementUuid}/`, {
    points: measurementDetailsObj.points,
    annotation_uuid: measurementDetailsObj.annotationUuid,
  })
}

const deleteImageMeasurement = (measurementDetailsObj) => {
  return irisMeasurementClient.delete(`/${measurementDetailsObj.measurementValues.measurementUuid}/`)
}

const getImageMeasurementsFiltered = (params?) => {
  return irisMeasurementClient.get(`/`, {
    params,
    paramsSerializer: filterParamSerializer,
  })
}

export { createImageMeasurement, updateImageMeasurement, deleteImageMeasurement, getImageMeasurementsFiltered }
